export default "__VITE_ASSET__df3fe539__"